export default {
  API_URL: process.env.API_URL,
  PRICE_MAP: {
    Z : {
      name : 'Niete',
      deg: 0
    },
    A : {
      name : 'Künstlerdose Angela Lyn 700g',
      deg: 36
    },
    B : {
      name:'Boîte Sélection 795g',
      deg: 108
    },
    C : {
      name: 'Kambly Primavera 175g',
      deg: 180
    },
    D : {
      name: 'Dose Aquarell Butterfly au Chocolat',
      deg: 252
    },
    E : {
      name: 'Onlineshop-Gutschein',
      deg: 324
    }
  },
  COMPETITION_FINISHED: process.env.VUE_APP_COMPETITION_FINISHED
}